import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const GOLD = '#B8892A';
const INK = '#1A1410';
const INK3 = '#6B5840';
const BG = '#FAF8F5';

const S = {
  page: { minHeight: '100vh', background: BG, paddingBottom: 60 },
  header: {
    position: 'sticky', top: 0, zIndex: 10, background: '#fff',
    borderBottom: '1px solid #EAE5DC', display: 'flex', alignItems: 'center',
    padding: '12px 16px', gap: 12,
  },
  back: {
    border: 'none', background: 'none', fontSize: 20, cursor: 'pointer',
    color: INK, padding: 0, lineHeight: 1,
  },
  title: { fontSize: 16, fontWeight: 600, color: INK },
  body: { padding: '20px 16px', maxWidth: 640, margin: '0 auto' },
  section: { marginBottom: 28 },
  h1: { fontSize: 18, fontWeight: 700, color: GOLD, marginBottom: 16 },
  h2: { fontSize: 15, fontWeight: 600, color: INK, marginBottom: 10, marginTop: 20 },
  p: { fontSize: 13, color: INK3, lineHeight: 1.8, marginBottom: 6 },
  ul: { fontSize: 13, color: INK3, lineHeight: 1.8, paddingLeft: 20, marginBottom: 6 },
  divider: { height: 1, background: '#EAE5DC', margin: '24px 0' },
};

export default function HelpBiddingGuide() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleBack = () => {
    if (location.state?.from) navigate(location.state.from);
    else navigate(-1);
  };
  return (
    <div style={S.page}>
      <div style={S.header}>
        <button style={S.back} onClick={handleBack}>&larr;</button>
        <span style={S.title}>参拍须知</span>
      </div>
      <div style={S.body}>
        <div style={S.section}>
          <h2 style={S.h1}>参拍须知</h2>

          <h3 style={S.h2}>1. 平台服务说明</h3>
          <p style={S.p}>云川中古提供日本拍卖会、中古市场、质店及相关平台的代拍服务。</p>
          <p style={S.p}>本平台与日本拍卖会实时同步，商品价格、竞拍状态、结束时间等信息以拍卖会实际页面为准。</p>
          <p style={S.p}>客户可根据页面显示价格提交委托出价，本平台将按照客户确认的金额进行代拍。</p>
          <p style={S.p}>代拍属于客户委托购买行为，并非普通现货销售。请客户确认好商品信息、预算及拍卖时间后再提交委托。</p>

          <div style={S.divider} />

          <h3 style={S.h2}>2. 保证金及出价规则</h3>
          <p style={S.p}>部分商品委托前需支付保证金。</p>
          <ul style={S.ul}>
            <li>未中拍：保证金可退回，或保留为余额下次使用。</li>
            <li>中拍成功：保证金自动抵扣尾款。</li>
            <li>中拍后取消：保证金不予退还。</li>
          </ul>
          <p style={S.p}>客户提交委托后，即代表授权本平台按照客户确认金额参与竞拍。</p>
          <p style={S.p}>委托一旦提交，原则上不可随意取消、修改、撤回或反悔。</p>
          <p style={S.p}>如中拍后客户因个人原因不要、拒绝付款或逾期付款，保证金不予退还，并可能影响后续代拍资格。</p>

          <div style={S.divider} />

          <h3 style={S.h2}>3. 暗拍说明</h3>
          <p style={S.p}>部分拍卖会或商品属于暗拍形式。</p>
          <p style={S.p}>暗拍不是实时公开竞价，客户无法看到其他买家的出价，也无法确认当前最高价。</p>
          <p style={S.p}>客户需提前填写自己可接受的最高委托价，本平台将按照客户确认金额提交。</p>
          <p style={S.p}>暗拍提交后，原则上无法取消、修改或撤回。</p>
          <p style={S.p}>最终是否中拍，以拍卖会公布结果为准，本平台不保证一定中拍。</p>

          <div style={S.divider} />

          <h3 style={S.h2}>4. 竞拍结果及低价商讨</h3>
          <p style={S.p}>竞拍过程中可能出现以下情况：</p>
          <ul style={S.ul}>
            <li>其他买家出价更高</li>
            <li>拍卖会自动延时</li>
            <li>系统刷新延迟</li>
            <li>商品临时撤拍</li>
            <li>卖家取消交易</li>
            <li>拍卖会判定成交无效</li>
            <li>商品信息临时变更</li>
          </ul>
          <p style={S.p}>最终结果以拍卖会或平台实际成交记录为准。</p>
          <p style={S.p}>部分拍卖会存在低价商讨机制。当落槌价格明显低于卖家或拍卖会预期时，即使系统显示中拍，也可能需要等待卖家最终确认。</p>
          <p style={S.p}>商讨结果可能包括：</p>
          <ul style={S.ul}>
            <li>原价成交</li>
            <li>卖家要求加价成交</li>
            <li>卖家拒绝成交</li>
            <li>拍卖会判定成交无效</li>
          </ul>
          <p style={S.p}>如遇低价商讨，本平台会第一时间与客户沟通。若客户不接受加价，或卖家拒绝成交，则该商品视为未成交。</p>
          <p style={S.p}>低价商讨属于拍卖会规则，并非本平台额外加价或隐形收费。</p>

          <div style={S.divider} />

          <h3 style={S.h2}>5. 账号安全规则</h3>
          <p style={S.p}>云川中古代拍账号仅限平台内部使用。</p>
          <p style={S.p}>客户不得借用、租用、转借、转租、共享、买卖本平台账号。</p>
          <p style={S.p}>客户不得私自登录、代替操作、传播后台截图、泄露拍卖会信息，或将账号相关内容提供给第三方。</p>
          <p style={S.p}>如因客户违规行为导致账号异常、封禁、纠纷、损失或法律责任，均由客户自行承担。</p>
          <p style={S.p}>严重违规者，本平台有权终止服务，并拒绝后续委托。</p>
        </div>
      </div>
    </div>
  );
}
